// eslint-disable-next-line no-control-regex
const SEVEN_BIT_ASCII_REGEX = /^[\x00-\x7F]*$/;

const RFC_5322_EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export interface Validator {
  (value, validationScope?): string | undefined;
}

export interface ValidatorFactory {
  (...args): Validator;
}

export const validators = {
  required: (field) => (value) => {
    if (!value) {
      return `${field || 'Value'} is required.`;
    }
  },
  maxLength: (maxLength, field) => (value) => {
    if (value && value.length >= maxLength) {
      return `${
        field || 'Value'
      } is too long (maximum length is ${maxLength} characters).`;
    }
  },
  email: (value) => {
    if (
      value &&
      !(
        SEVEN_BIT_ASCII_REGEX.test(value.split('@')[0]) &&
        RFC_5322_EMAIL_REGEXP.test(value)
      )
    ) {
      return 'Email is not valid.';
    }
  },
  phone: (value) => {
    if (
      value &&
      !/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/.test(
        value,
      )
    ) {
      return 'Phone number is invalid.';
    }
  },
  website: (value) => {
    if (
      value &&
      !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(
        value,
      )
    ) {
      return 'Website address is not valid';
    }
  },
  compose:
    (...validators) =>
    (...validationArgs) => {
      for (const validator of validators) {
        const error = validator(...validationArgs);

        if (error) {
          return error;
        }
      }
    },
  validateSelected:
    (validator, selector) =>
    (value, ...restValidationArgs) => {
      value = selector ? selector(value) : value;

      return validator(value, ...restValidationArgs);
    },
  validateIf:
    (validator, condition) =>
    (...validationArgs) => {
      if (condition(...validationArgs)) {
        return validator(...validationArgs);
      }
    },
};
